<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <!-- AcademicYear -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Semester -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Level -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Period -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label>{{ $t("messages.general.periodStu") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Period :onChanged="onSelPeriod" :selectedVal="seleriod" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Export Report Button -->
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="handleExportReport('PDF')"
                    type="button"
                  >
                    {{ $t("messages.general.printReport") }} PDF</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-lg"
                    @click="handleExportReport('EXCEL')"
                    type="button"
                  >
                    {{ $t("messages.general.printReport") }} EXCEL</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="clearAll()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- Error Dialog -->
      <v-dialog v-model="dialogError" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="red darken-3">
            <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
            <v-toolbar-title style="color: #ffebee;"
              >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogError = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="red accent-1">
            <br />
            <span style="color: red;">{{ errorText }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "@/components/Dropdown/AcademicYear";
import Semester from "@/components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Period from "@/components/Dropdown/Period";

export default {
  name: "rpterctstdconfirmbyco",
  components: {
    AcademicYear,
    Semester,
    Level,
    Period
  },
  data() {
    return {
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      seleriod: 0,
      isEdit: false,
      dialogError: false,
      errorText: "",
      dialogErrorTitle: ""
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelPeriod(event) {
      this.seleriod = parseInt(event.target.value);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async handleExportReport(reportType) {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);
        const response = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}report/rpterctstdconfirmbyco`,
          {
            params: {
              acadyear: this.selYear,
              semester: this.selSemester,
              levelid: this.selLvl,
              period: "A",
              lang: this.appInfo.currentLocale.toUpperCase(),
              report_type: reportType,
              file:
                "Rpterctstdconfirmbyco" +
                (reportType === "PDF" ? ".pdf" : ".xlsx")
            }
          }
        );

        if (response.status === 200) {
          // Queue Report
          let isWaitAndContinue = true;
          let responseAfterCheckQueue = {};
          while (isWaitAndContinue) {
            console.log("checking..");
            const resultQueueStatus = await axios.get(
              `${process.env.VUE_APP_API_ENDPOINT}report/queue`,
              {
                params: {
                  queue_id: response.data.data.queue_id
                }
              }
            );
            if (
              resultQueueStatus.status === 200 &&
              (resultQueueStatus.data.data.status !== "pending" &&
                resultQueueStatus.data.data.status !== "processing")
            ) {
              isWaitAndContinue = false;
              responseAfterCheckQueue = resultQueueStatus;
              break;
            }
            console.log("attemping to retry.");
            await this.sleep(3 * 1000);
          }

          if (responseAfterCheckQueue.data.data.status === "error") {
            this.dialogErrorTitle = "";
            this.dialogError = true;
            if (
              responseAfterCheckQueue.data.data.message.trim() ===
              "404_NOT_FOUND"
            ) {
              this.errorText = "Report no data found.";
            } else {
              this.errorText = responseAfterCheckQueue.data.data.message;
            }
          } else {
            // Download file
            const resultDownload = await axios.get(
              `${process.env.VUE_APP_API_ENDPOINT}report/queue/file`,
              {
                responseType: "blob",
                params: {
                  queue_id: responseAfterCheckQueue.data.data.queue_id,
                  file_name: responseAfterCheckQueue.data.data.file
                }
              }
            );

            const url = window.URL.createObjectURL(resultDownload.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              responseAfterCheckQueue.data.data.file
            );
            document.body.appendChild(link);
            link.click();
          }
        } else {
          // display error
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `ไม่สามารถดาวโหลดรายงานได้`;
        }

        this.togglePreLoader(false);
      }
    },
    clearAll() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
    }
  },
  watch: {
    async currentLang() {}
  }
};
</script>
